export default {
  // AutonomousTeachingActivityView
  editActivity: 'Editar Actividad de Trabajo Autónomo',
  deleteActivityConfirmation: '¿Está seguro de que desea eliminar la Actividad de Trabajo Autónomo?',
  activityDeleted: 'Actividad de Trabajo Autónomo eliminada.',
}
